module.exports = __webpack_public_path__ + "img/angular_arrow.f784b47f.svg";